import React, { useState, useEffect } from "react";
import { Offcanvas } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
// Importaciones con manejo de errores
let conditionsData, ageData, relationData, resultData, severitiesData, allergiesData, treatmentData, allergyOptionsData;

try {
    conditionsData = require("../../../../data/conditions.json");
} catch (e) {
    conditionsData = { conditions: [] };
}

try {
    ageData = require("../../../../data/age.json");
} catch (e) {
    ageData = { age: [] };
}

try {
    relationData = require("../../../../data/relation.json");
} catch (e) {
    relationData = { relation: [] };
}

try {
    resultData = require("../../../../data/resultsOptions.json");
} catch (e) {
    resultData = { results: [] };
}

try {
    severitiesData = require("../../../../data/severities.json");
} catch (e) {
    severitiesData = { severities: [] };
}

try {
    allergiesData = require("../../../../data/allergyOptions.json");
} catch (e) {
    allergiesData = { allergyOptions: [] };
}

try {
    treatmentData = require("../../../../data/treatmentPlans.json");
} catch (e) {
    treatmentData = { treatmentPlans: [] };
}

try {
    allergyOptionsData = require("../../../../data/allergyOptions.json");
} catch (e) {
    allergyOptionsData = { allergyOptions: [] };
}

// Componente Modal simulado si no existe
const ModalComponent = ({ onSave, modalId }) => (
    <button 
        type="button" 
        className="btn btn-outline-primary btn-sm"
        onClick={() => onSave({ date: '2023-01-01', startTime: '09:00', endTime: '10:00' }, modalId)}
    >
        Add Other
    </button>
);

const PatientMedicalClinicalData = ({ selectedPatientMedical, showPanelMedical, setShowPanelMedical }) => {
    // Estados del componente
    const [nameCondition, setNameCondition] = useState("");
    const [diagnosisDateCondition, setDiagnosisDateCondition] = useState("");
    const [severitySelectCondition, setSeveritySelectCondition] = useState("");
    const [treatmentPlanSelectCondition, setTreatmentPlanSelectCondition] = useState("");
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [nameMedicalHistory, setNameMedicalHistory] = useState("");
    const [diagnosisDateMedicalHistory, setDiagnosisDateMedicalHistory] = useState("");
    const [outcomesMedicalHistory, setOutcomesMedicalHistory] = useState("");
    const [allergiesSelectMedicalHistory, setAllergiesSelectMedicalHistory] = useState("");
    const [nameFamilyHistory, setNameFamilyHistory] = useState("");
    const [relationshiptoPatient, setRelationshiptoPatient] = useState("");
    const [ageOnset, setAgeOnset] = useState("");
    const [nameMedication, setNameMedication] = useState("");
    const [dosageMedication, setDosageMedication] = useState("");
    const [reasonMedication, setReasonMedication] = useState("");
    const [selectedCondition, setSelectedCondition] = useState("");
    const [diagnosisDate, setDiagnosisDate] = useState("");
    const [refill, setRefill] = useState("");
    const [heightVital, setHeightVital] = useState("");
    const [weightVital, setWeightVital] = useState("");
    const [bloodPressureVital, setBloodPressureVital] = useState("");
    const [BMIVital, setBMIVital] = useState("");
    const [heartRateVital, setHeartRateVital] = useState("");
    const [respiratoryRate, setRespiratoryRate] = useState("");
    const [temperatureVital, setTemperatureVital] = useState("");
    const [typeLab, setTypeLab] = useState("");
    const [dateTestLab, setDateTestLab] = useState("");
    const [resultsLab, setResultsLab] = useState("");
    const [dateVitals, setDateVitals] = useState("");
    const [timeOfRecording, setTimeOfRecording] = useState("");
    const [recordingMethod, setRecordingMethod] = useState("");
    const [allergies, setAllergies] = useState("");
    const [severityReaction, setSeverityReaction] = useState("");
    const [dateLastReason, setDateLastReason] = useState("");

    const [modalData, setModalData] = useState({
        modal1: null,
        modal2: null,
        modal3: null,
        modal4: null,
        modal5: null,
        modal6: null,
    });

    // Debug: Agregar logs para verificar el estado
    useEffect(() => {
        console.log('Offcanvas state changed:', showPanelMedical);
        console.log('Selected patient:', selectedPatientMedical);
    }, [showPanelMedical, selectedPatientMedical]);

    const handleSaveModalData = (data, modalId) => {
        console.log('Saving modal data:', data, modalId);
        setModalData(prevState => ({
            ...prevState,
            [modalId]: data,
        }));
    };

    const handleFileChangeCurrents = (e) => {
        console.log('File change:', e.target.files);
        const files = Array.from(e.target.files);
        setSelectedFiles((prevFiles) => [...prevFiles, ...files]);
    };
    
    const handleFileChangeLabResult = (e) => {
        console.log('Lab file change:', e.target.files);
        const files = Array.from(e.target.files);
        setSelectedFiles((prevFiles) => [...prevFiles, ...files]);
    };
    
    const handleDeleteFile = (index) => {
        console.log('Deleting file at index:', index);
        const updatedFiles = selectedFiles.filter((_, i) => i !== index);
        setSelectedFiles(updatedFiles);
    };

    const handleClosePanel = () => {
        console.log('Closing panel');
        setShowPanelMedical(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Form submitted');
        
        const formData = new FormData();
        formData.append("condition", nameCondition);
        formData.append("diagnosisDate", diagnosisDateCondition);
        formData.append("severity", severitySelectCondition);
        formData.append("treatmentPlan", treatmentPlanSelectCondition);
        selectedFiles.forEach((file) => formData.append("files", file));
        formData.append("nameMedicalHistory", nameMedicalHistory);
        formData.append("diagnosisDateMedicalHistory", diagnosisDateMedicalHistory);
        formData.append("outcomesMedicalHistory", outcomesMedicalHistory);
        formData.append("allergy", allergiesSelectMedicalHistory);
        formData.append("nameFamilyHistory", nameFamilyHistory);
        formData.append("relationshiptoPatient", relationshiptoPatient);
        formData.append("ageOnset", ageOnset);
        formData.append("nameMedication", nameMedication);
        formData.append("dosageMedication", dosageMedication);
        formData.append("reasonMedication", reasonMedication);
        formData.append("prescribingDoctor", selectedCondition);
        formData.append("startDate", diagnosisDate);
        formData.append("refillInformation", refill);
        formData.append("heightVital", heightVital);
        formData.append("weightVital", weightVital);
        formData.append("bloodPressureVital", bloodPressureVital);
        formData.append("BMIVital", BMIVital);
        formData.append("heartRateVital", heartRateVital);
        formData.append("respiratoryRate", respiratoryRate);
        formData.append("temperatureVital", temperatureVital);
        formData.append("typeLab", typeLab);
        formData.append("dateTestLab", dateTestLab);
        formData.append("resultsLab", resultsLab);
        formData.append("dateVital", dateVitals);
        formData.append("timeOfRecording", timeOfRecording);
        formData.append("recordingMethod", recordingMethod);

        console.log("Enviando datos a la API...", {
            nameCondition,
            diagnosisDateCondition,
            severitySelectCondition,
            treatmentPlanSelectCondition,
            selectedFiles
        });

        // Simular llamada exitosa
        alert('Datos guardados correctamente');
        handleClosePanel();
    };

    // Si no se debe mostrar, no renderizar nada
    if (!showPanelMedical) {
        return null;
    }

    return (
        <>
            {/* Overlay personalizado para debug */}
            <div 
                className="offcanvas-backdrop fade show" 
                style={{ 
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 1040,
                    backgroundColor: 'rgba(0,0,0,0.5)'
                }}
                onClick={handleClosePanel}
            />
            
            <div
                className={`offcanvas offcanvas-end show`}
                tabIndex={-1}
                style={{ 
                    width: '60%',
                    zIndex: 1050,
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    height: '100vh',
                    visibility: 'visible',
                    transform: 'translateX(0)'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="offcanvas-header border-bottom">
                    <h5 className="offcanvas-title">
                        Patient Medical and Clinical Data for {selectedPatientMedical?.name || 'Unknown Patient'}
                    </h5>
                    <button 
                        type="button" 
                        className="btn-close" 
                        aria-label="Close"
                        onClick={handleClosePanel}
                    />
                </div>
                
                <div className="offcanvas-body" style={{ overflowY: 'auto' }}>
                    <form onSubmit={handleSubmit}>
                        {/* Current Conditions Section */}
                        <section className="container-fluid mt-4 border p-3 rounded">
                            <h2>Current Conditions</h2>
                            <hr />
                            <div className="row mb-3">
                                <div className="col-md-3">
                                    <label className="mb-2" htmlFor="nameCondition" style={{ fontWeight: 'bold', color: '#000' }}>
                                        Condition Name
                                    </label>
                                    <select
                                        id="nameCondition"
                                        className="form-select"
                                        value={nameCondition}
                                        onChange={(e) => {
                                            console.log('Condition changed:', e.target.value);
                                            setNameCondition(e.target.value);
                                        }}
                                    >
                                        <option value="">Select Condition</option>
                                        {conditionsData?.conditions?.map((condition) => (
                                            <option key={condition.id} value={condition.id}>
                                                {condition.name}
                                            </option>
                                        )) || []}
                                        {/* Opciones de fallback si no hay datos */}
                                        <option value="1">Diabetes</option>
                                        <option value="2">Hypertension</option>
                                        <option value="3">Asthma</option>
                                    </select>
                                </div>

                                <div className="col-md-3">
                                    <label className="mb-2" htmlFor="diagnosisDateCondition" style={{ fontWeight: 'bold', color: '#000' }}>
                                        Date of Diagnosis
                                    </label>
                                    <input
                                        type="date"
                                        id="diagnosisDateCondition"
                                        className="form-control"
                                        value={diagnosisDateCondition}
                                        onChange={(e) => {
                                            console.log('Date changed:', e.target.value);
                                            setDiagnosisDateCondition(e.target.value);
                                        }}
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label className="mb-2" htmlFor="severitySelectCondition" style={{ fontWeight: 'bold', color: '#000' }}>
                                        Severity
                                    </label>
                                    <select
                                        id="severitySelectCondition"
                                        className="form-select"
                                        value={severitySelectCondition}
                                        onChange={(e) => {
                                            console.log('Severity changed:', e.target.value);
                                            setSeveritySelectCondition(e.target.value);
                                        }}
                                    >
                                        <option value="">Select Severity</option>
                                        {severitiesData?.severities?.map((severity) => (
                                            <option key={severity.id} value={severity.id}>
                                                {severity.name}
                                            </option>
                                        )) || []}
                                        {/* Opciones de fallback */}
                                        <option value="mild">Mild</option>
                                        <option value="moderate">Moderate</option>
                                        <option value="severe">Severe</option>
                                    </select>
                                </div>

                                <div className="col-md-3">
                                    <label className="mb-2" htmlFor="treatmentPlanSelectCondition" style={{ fontWeight: 'bold', color: '#000' }}>
                                        Treatment Plan
                                    </label>
                                    <select
                                        id="treatmentPlanSelectCondition"
                                        className="form-select"
                                        value={treatmentPlanSelectCondition}
                                        onChange={(e) => {
                                            console.log('Treatment changed:', e.target.value);
                                            setTreatmentPlanSelectCondition(e.target.value);
                                        }}
                                    >
                                        <option value="">Select Treatment Plan</option>
                                        {treatmentData?.treatmentPlans?.map((plan) => (
                                            <option key={plan.value} value={plan.value}>
                                                {plan.label}
                                            </option>
                                        )) || []}
                                        {/* Opciones de fallback */}
                                        <option value="medication">Medication</option>
                                        <option value="therapy">Therapy</option>
                                        <option value="surgery">Surgery</option>
                                    </select>
                                </div>
                            </div>

                            <div className="row align-items-start">
                                <div className="col-md-4">
                                    <label className="mb-2" htmlFor="fileUploadCondition" style={{ fontWeight: 'bold', color: '#000' }}>
                                        Medical Records or Documents
                                    </label>
                                    <input
                                        type="file"
                                        id="fileUploadCondition"
                                        className="form-control"
                                        multiple
                                        accept=".pdf, .doc, .docx, .jpg, .jpeg, .png"
                                        onChange={handleFileChangeCurrents}
                                    />
                                </div>

                                <div className="col-md-8 d-flex flex-wrap gap-3">
                                    {selectedFiles.length > 0 && (
                                        selectedFiles.map((file, index) => (
                                            <div key={index} className="card p-3" style={{ width: "150px", textAlign: "center", position: "relative" }}>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm position-absolute top-0 end-0 m-1"
                                                    onClick={() => handleDeleteFile(index)}
                                                    style={{
                                                        color: "red",
                                                        backgroundColor: "transparent",
                                                        border: "1px solid red",
                                                        borderRadius: "50%",
                                                        padding: "0.2rem 0.4rem",
                                                        fontWeight: "bold"
                                                    }}
                                                >
                                                    X
                                                </button>

                                                <div className="file-icon mb-2">
                                                    📄
                                                </div>

                                                <small>{file.name}</small>

                                                <div className="mt-2">
                                                    <small>{(file.size / 1024).toFixed(2)} KB</small>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                                <div className="w-25 mt-3">
                                    <ModalComponent onSave={handleSaveModalData} modalId="modal1" />
                                </div>
                                {modalData.modal1 && (
                                    <div className="col-md-4 mt-3">
                                        <div className="border p-3 rounded position-relative">
                                            <button
                                                type="button"
                                                className="btn-close position-absolute top-0 end-0"
                                                aria-label="Close"
                                                onClick={() => setModalData(prevState => ({ ...prevState, modal1: null }))}
                                            />
                                            <p><strong>Date:</strong> {modalData.modal1.date}</p>
                                            <p><strong>Start Time:</strong> {modalData.modal1.startTime}</p>
                                            <p><strong>End Time:</strong> {modalData.modal1.endTime}</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </section>

                        {/* Past Medical History Section */}
                        <section className="container-fluid mt-4 border p-3 rounded">
                            <h2>Past Medical History</h2>
                            <hr />
                            <div className="row mb-3">
                                <div className="col-md-3">
                                    <label className="mb-2" htmlFor="nameMedicalHistory" style={{ fontWeight: 'bold', color: '#000' }}>
                                        Name
                                    </label>
                                    <input
                                        type="text"
                                        id="nameMedicalHistory"
                                        className="form-control"
                                        value={nameMedicalHistory}
                                        onChange={(e) => setNameMedicalHistory(e.target.value)}
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label className="mb-2" htmlFor="diagnosisDateMedicalHistory" style={{ fontWeight: 'bold', color: '#000' }}>
                                        Dates
                                    </label>
                                    <input
                                        type="date"
                                        id="diagnosisDateMedicalHistory"
                                        className="form-control"
                                        value={diagnosisDateMedicalHistory}
                                        onChange={(e) => setDiagnosisDateMedicalHistory(e.target.value)}
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label className="mb-2" htmlFor="outcomesMedicalHistory" style={{ fontWeight: 'bold', color: '#000' }}>
                                        Outcomes
                                    </label>
                                    <input
                                        type="text"
                                        id="outcomesMedicalHistory"
                                        className="form-control"
                                        value={outcomesMedicalHistory}
                                        onChange={(e) => setOutcomesMedicalHistory(e.target.value)}
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label className="mb-2" htmlFor="allergiesSelectMedicalHistory" style={{ fontWeight: 'bold', color: '#000' }}>
                                        Allergies
                                    </label>
                                    <select
                                        id="allergiesSelectMedicalHistory"
                                        className="form-select"
                                        value={allergiesSelectMedicalHistory}
                                        onChange={(e) => setAllergiesSelectMedicalHistory(e.target.value)}
                                    >
                                        <option value="">Select Allergy</option>
                                        {allergiesData?.allergyOptions?.map((allergy) => (
                                            <option key={allergy.value} value={allergy.value}>
                                                {allergy.label}
                                            </option>
                                        )) || []}
                                        <option value="peanuts">Peanuts</option>
                                        <option value="shellfish">Shellfish</option>
                                        <option value="penicillin">Penicillin</option>
                                    </select>
                                </div>
                            </div>
                        </section>

                        {/* Botones de acción */}
                        <div className="d-flex justify-content-end gap-2 mt-4 mb-3">
                            <button 
                                type="button" 
                                className="btn btn-secondary" 
                                onClick={handleClosePanel}
                            >
                                Cancel
                            </button>
                            <button 
                                type="submit" 
                                className="btn btn-primary"
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default PatientMedicalClinicalData;